export default "__VITE_ASSET__CasdfT6H__"